import { Action } from "redux";
import { ofType, StateObservable } from "redux-observable";
import { Observable, of } from "rxjs";
import { AppState, PlanActions } from "../types";
import { getFailurePayloadOf, getStartTypeOf, getSuccessPayloadOf } from "../utils/redux";
import {
  catchError,
  switchMap,
  map,

} from 'rxjs/operators';
import { firestore } from "../firebase";
import { collectionData } from 'rxfire/firestore';


const fetchPlansEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) => {
  return  action$.pipe(
    ofType(getStartTypeOf(PlanActions.FETCH_PLANS)),
    switchMap((() => {
      const userId = state$.value.firebase.auth.uid;
      console.log({userId});
      const plansRef = firestore.collection('plans')
        .where('advisor_id', '==', userId)
        .orderBy('created_at', 'desc');
      return collectionData(plansRef, 'id')
        .pipe(
          map(plans => {
            console.log({plans});
            return getSuccessPayloadOf(PlanActions.FETCH_PLANS, plans)
          }),
          catchError((_e) => {
            console.log(_e);
            return of(getFailurePayloadOf(PlanActions.FETCH_PLANS));
          }),
        )
    }))
  )
}

const epicList = [
  fetchPlansEpic,
];

export default epicList;